<template>
  <div
    id="bp-opener"
    class="container-fluid"
    :style="'background-color:' + componentBgColor"
  >
    <div class="row h-100">
      <div
        class="col-12 image-header h-100"
        :style="{ 'background-image': 'url(' + component.images[0] + ')' }"
      >
	  	<div v-if="showOverlay == 'true'" class="image-overlay"></div>
        <div class="container h-100">
          <div
            class="row d-flex align-items-center justify-content-center text-center h-100"
          >
            <div class="col-12 col-lg-10 content-parent">
              <h1 class="heading-main">{{ component.content.title }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showCallout == 'true'" class="callout-parent container-fluid">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
          <div v-if="showAlternateContent == 'true'" class="callout-panel text-center">`
              <h4 class="copy-heading-sub">{{ component.calloutTextAlt }}</h4>
              <!-- <a href="#" class="btn bp-btn">Send Andrew an Email</a> -->
              <a href="mailto:bianca@bellingenproperty.com.au?subject=Like to join the Bellingen Connections page" class="btn bp-btn">Send Bianca an email</a>
            </div>
            <div v-else class="callout-panel text-center">
              <div class="container-fluid">
                <div class="row">
                  <h4 class="copy-heading-sub">{{ component.calloutText }}</h4>
                </div>
                <div class="row justify-content-center">
                  <div
                    class="col-12 col-lg-6"
                    v-for="data in component.contacts"
                  >
                    <h4 class="copy-callout-name">{{ data.name }}</h4>
                    <a :href="'tel:' + data.phoneNumber.replaceAll(' ', '')">
                      <h4 class="copy-callout-phone">{{ data.phoneNumber.replace( '+61 2 ', '0' ) }}</h4>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// load components

export default {
  name: "opener",
  props: [
    "componentTitle",
    "componentImage",
    "componentBgColor",
    "showCallout",
	  "showOverlay",
    "showAlternateContent"
  ],
  data() {
    return {
      component: {
        images: [this.componentImage],
        altcontent: this.showAlternateContent,
        content: {
          title: this.componentTitle,
        },
        calloutText:  "For all enquires contact",
        contacts:[
          {
            name:         "Andrew",
            phoneNumber:  "+61 2 428195664",
          }
        ],
        calloutTextAlt: "Want to join Our Bellingen Connections"
      },
    };
  },
};
</script>

<style lang="scss" scoped>
// global vars
@import "../../scss/vars.one3design.scss";

// global mixins
@import "../../scss/mixins.one3design.scss";

// component styles
#bp-opener {
  height: 85vh;
  position: relative;
  z-index: 1;
  .image-header {
    @include images(center, cover);
    .content-parent {
		z-index:+1;
      .heading-main {
        color: $white;
        font-family: "IBM Plex Serif", serif;
        letter-spacing: 0.025em;
      }
    }
	.image-overlay {
		background-color:#000;
		background-blend-mode: multiply;
		bottom:0;
		content:'';
		left:0;
		opacity:.5;
		position:absolute;
		right:0;
		top:0;
		z-index:0;
	}
  }
  // mobile
  @media screen and (max-width: $mobile) {
    height: 100vh;
  }
}
.callout-parent {
  left: 0;
  position: relative;
  right: 0;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: +1;
  .callout-panel {
    box-shadow: 0 10px 30px #00253230;
    background-color: #fff;
    color: $text;
    margin-bottom: 2em;
    padding: 3em;
    .callout-label {
      color: $color_main;
      font-size: 1.25rem;
      font-weight: $font-weight-bold;
      margin-bottom: 2em;
    }
    a {
      align-items:center;
      cursor:pointer;
      display:inline-flex;
      justify-content:center;
      min-height:70px;
      &:first-child {
        margin-right:1em;
      }
      &:last-child {
        margin-left:1em;
      }
    }
  }
  @media screen and (max-width: $mobile) {
    .callout-panel {
      padding: 2em;
    }
  }
}
</style>
